import { Route, Routes, useLocation } from "react-router-dom";

import AOS from "aos";
import { useEffect } from "react";
import Layout from "./app/layout";
import Login from "./app/login";
import LoginBy from "./app/loginBy";
import NotFound from "./app/notFound";
import Attendance from "./students/attendance";
import Award from "./students/award";
import FeedBack from "./students/feedback";
import Notification from "./students/notification";
import NotificationDetails from "./students/notification/notificationDetails";
import Home from "./students/home";
import IDCard from "./students/idCard";
import Internship from "./students/internship";
import MyFees from "./students/myFees";
import ExamFees from "./students/examFee";
import PaymentStatus from "./students/myFees/paymentStatus";
import ProfileUpdation from "./students/profileUpdation";
import Service from "./students/service";
import StudentLayout from "./students/studentLayout";
import StudentLogin from "./students/studentLogin";
import StudentMyProfile from "./students/studentMyProfile";
import StudentRegister from "./students/studentRegister";
import VerifyStudentEmail from "./students/studentRegister/verifyStudentEmail";
import VerifyStudentMailOtp from "./students/studentRegister/verifyStudentMailOtp";
import VerifyStudentMobile from "./students/studentRegister/verifyStudentMobile";
import VerifyStudentOtp from "./students/studentRegister/verifyStudentOtp";
import StudentCertificates from "./students/utilities/studentCertificates";
import V2ForgotPassword from "./app/loginV2Forgot/v2ForgotPassword";
import V2OtpResetPassword from "./app/loginV2Forgot/v2OtpResetPassword";
import OpenPaymentRegistration from "./students/openPaymentForm/openPaymentRegistration";
import Convocation from "./students/convocation";
import HallTicket from "./students/hallticket";
import StudentIdCard from "./students/studentidcard";
import TargetSettings from "./students/targetSettings";
import ExamResults from "./students/exam_results";
import Elective from "./students/elective";
import ServiceOrganization from "./students/serviceorganization";
import LibraryList from "./students/libraryList";
import TermsPrivacy from "./students/terms/terms_privacy";
import Circular from "./students/circular";
import CircularDetails from "./students/circular/circularDetails";
import ExamFeeStatus from "./students/examFeeStatus";
import TransportRequest from "./students/transportRequest";
import AdmissionForm from "./students/admissionForm";
import TrackOrderStatus from "./students/myFees/trackOrderStatus";
import StudentTransfer from "./students/studentTransfer";

const RouteUrls = () => {
  const location = useLocation();

  useEffect(() => {
    AOS.init();
    /*{
      offset: 200,
      duration: 300,
      easing: "ease-in-sine",
      delay: 100,
    }*/
    //AOS.refresh();
  }, []);

  return (
    <>
      <Routes>
        <Route path="/staff/app/*" element={<Layout />}></Route>

        <Route path="/stu/app" element={<StudentLayout />}>
          <Route path="my-fees" element={<MyFees />} />
          <Route path="exam-fees" element={<ExamFees />} />
          <Route path="exam-fee-status" element={<ExamFeeStatus />} />
          <Route path="my-attendance" element={<Attendance />} />
          <Route path="my-profile" element={<StudentMyProfile />} />
          <Route path="hallticket" element={<HallTicket />} />
          <Route path="exam-results" element={<ExamResults />} />
          <Route path="elective" element={<Elective />} />
          <Route path="serviceorganization" element={<ServiceOrganization />} />
          <Route path="studentidcard" element={<StudentIdCard />} />
          <Route path="targetsettigs" element={<TargetSettings />} />
          <Route path="convocation" element={<Convocation />} />
          <Route path="internship" element={<Internship />} />
          <Route path="idCard" element={<IDCard />} />
          <Route path="service" element={<Service />} />
          <Route path="util/stucert" element={<StudentCertificates />} />
          <Route path="award" element={<Award />} />
          <Route path="feedback" element={<FeedBack />} />
          <Route path="notification" element={<Notification />} />
          <Route path="library" element={<LibraryList />} />
          <Route path="circular" element={<Circular />} />
          <Route path="transport-request" element={<TransportRequest />} />
          <Route path="circular/read/:id" element={<CircularDetails />} />
          <Route path="admission-card" element={<AdmissionForm />} />
          <Route path="track-order-status" element={<TrackOrderStatus />} />
          <Route path="online-transfer" element={<StudentTransfer />} />
          <Route
            path="notification/read/:id"
            element={<NotificationDetails />}
          />
          <Route path="" element={<Home />} />
        </Route>

        <Route path="/staff/login" element={<Login />} exact />
        <Route path="/staff/forgot-pass" element={<V2ForgotPassword />} exact />
        <Route
          path="/staff/forgot-pass-otp"
          element={<V2OtpResetPassword />}
          exact
        />

        <Route
          path="/stu/login/:college_uuid"
          element={<StudentLogin />}
          exact
        />
        <Route path="/terms-conditions/:id" element={<TermsPrivacy />} exact />
        <Route path="/stu/register" element={<StudentRegister />} exact />
        <Route
          path="/stu/open-form"
          element={<OpenPaymentRegistration />}
          exact
        />

        <Route
          path="/stu/verify-mobile"
          element={<VerifyStudentMobile />}
          exact
        />

        <Route path="/stu/verify-otp" element={<VerifyStudentOtp />} exact />

        <Route
          path="/stu/verify-email"
          element={<VerifyStudentEmail />}
          exact
        />
        <Route
          path="/stu/verify-mail-otp"
          element={<VerifyStudentMailOtp />}
          exact
        />
        <Route path="/stu/update-profile" element={<ProfileUpdation />} exact />
        <Route
          path="/stu/payment-status/:staus"
          element={<PaymentStatus />}
          exact
        />

        <Route path="/" element={<LoginBy />} exact />
        <Route path="*" element={<NotFound />} exact />
      </Routes>
    </>
  );
};

export default RouteUrls;
